const CUSTOMER_LOGOS = [
  { name: 'Eaxora', src: '/img/customer-logos/eaxora.png' },
  { name: 'mamsampark', src: '/img/customer-logos/mamsampark.png' },
  { name: 'Xshack', src: '/img/customer-logos/xshack.png' },
  { name: 'AI ERP', src: '/img/customer-logos/erp.png' },
  { name: 'BARS', src: '/img/customer-logos/BARS.jpeg' },
  { name: 'B2B Matrix', src: '/img/customer-logos/B2B-Matrix.png' },
  { name: 'CGS Tech Labs', src: '/img/customer-logos/cgs.png' },
  { name: 'Liquor Logic', src: '/img/customer-logos/LiquorLogic.png' },
  
];

export default CUSTOMER_LOGOS;
